module.exports = __webpack_public_path__ + "static/website-speed-18a3d6771e1fa8635b9a35e214a47f2f.png";